<template>
    <!--<v-layout row justify-center align-center pt-5 pl-10>-->
    <v-container>
        <v-row>
            <v-col class="col-8">
                    <v-text-field
                            v-bind:label="$t('Description')"
                            v-model="signature.description"
                            maxlength="100"
                            :counter="100"
                            :error-messages="signatureFormErrors"
                            @input="$v.signature.description.$touch()"
                            @blur="$v.signature.description.$touch()"
                    ></v-text-field>
            </v-col>
            <v-col class="col-4">
                <v-checkbox v-model="signature.isDefault"
                            v-bind:label="$t('IsDefault')">
                </v-checkbox>
            </v-col>

        </v-row>
        <template v-if="renderSignature">
          <ImageCropper :oldImage="signature.signatureImage"
                        :onChange="changeSignatureImage"
                        ref="imageCropper">
          </ImageCropper>
        </template>
        <v-row>
            <div class="col-12">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                v-on="on"
                                outlined
                                color="primary"
                                icon
                                @click="saveSignature"
                                class="mr-2"
                        >
                            <v-icon>mdi-check</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("Edit") }}</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                                v-on="on"
                                outlined
                                color="primary"
                                icon
                                @click="cancel"
                        >
                            <v-icon>mdi-cancel</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("Cancel") }}</span>
                </v-tooltip>
            </div>
        </v-row>
    </v-container>
</template>
<script>

import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Utils from '@/ecm/common/Utils';
import ImageCropper from '@/components/base/ImageCropper.vue';

export default {
    components: { ImageCropper },
    mounted() {
        this.renderSignature = true;
        if (this.$refs.imageCropper) {
            this.$refs.imageCropper.reset();
        }
    },
    name: 'UserSignature',
    props: {
        onCancel: Function,
        onValidate: Function
    },
    data() {
        return {
            renderSignature: false, //Ugly fix for signature img in edition
            signature: {},
            imgSrc: null
        };
    },
    mixins: [validationMixin],
    validations: {
        signature: {
            description: { required },
            signatureImage: { required },
        },
    },
    computed: {
        signatureFormErrors() {
            const errors = [];
            if (!this.$v.signature.description.$dirty) return errors;
            !this.$v.signature.description.required && errors.push(this.$t('RequiredField'));
            return errors;
        },
        signatureImageErrors() {
            const errors = [];
            if (!this.$v.signature.signatureImage.$dirty) return errors;
            !this.$v.signature.signatureImage.required &&
                errors.push(this.$t('RequiredField'));
            return errors;
        },
    },
    methods: {
        setSignatureForEdit(signature) {
            this.signature = signature;
            this.renderSignature = true;
        },
        saveSignature() {
            this.$v.$touch();

            if (this.$v.$invalid) {
                if (!this.signature.signatureImage) {
                    Utils.toast.error(this.$t('ImageIsRequiredException'));
                }

                return;
            }

            if (this.onValidate(this.signature)) {
                this.renderSignature = false;
                this.$emit('saveSignature', this.signature);
            }
        },
        cancel() {
            this.renderSignature = false;
            this.imgSrc = null;

            if (this.$refs.imageCropper) {
                this.$refs.imageCropper.reset();
            }

            this.onCancel();
        },
        changeSignatureImage(newImage) {
            this.signature.signatureImage = newImage;
            this.signature.signatureImageHasChanged = true;
        }
    }
};
</script>
